export default {
  maxLayoutWidth: 1000,
  mobileThreshold: 768,
  navBarHeight: 70,
};
